import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Logo } from "@/components/site/Logo";
import { scrollToId } from "@/components/site/SmoothScroll";

const LINKS = [
  { to: "/eventos", label: "Eventos" },
  { to: "/fotografos", label: "Fotógrafos" },
  { hash: "como-funciona", label: "Como funciona" },
  { hash: "proponha", label: "Proponha um evento" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();
  const nav = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const goHash = (hash) => {
    setOpen(false);
    if (pathname === "/") scrollToId(hash);
    else {
      nav("/");
      setTimeout(() => scrollToId(hash), 450);
    }
  };

  const item = (l, mobile) =>
    l.to ? (
      <NavLink key={l.label} to={l.to} data-testid={`nav-${l.to.slice(1)}${mobile ? "-mobile" : ""}`}
        className={({ isActive }) => `${mobile ? "text-3xl font-display font-bold" : "text-sm"} transition-colors duration-300 hover:text-flash ${isActive ? "text-flash" : "text-foreground/85"}`}>
        {l.label}
      </NavLink>
    ) : (
      <button key={l.label} onClick={() => goHash(l.hash)} data-testid={`nav-${l.hash}${mobile ? "-mobile" : ""}`}
        className={`${mobile ? "text-left text-3xl font-display font-bold" : "text-sm"} text-foreground/85 transition-colors duration-300 hover:text-flash`}>
        {l.label}
      </button>
    );

  return (
    <header className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${scrolled || open ? "border-b border-white/10 bg-ink/75 backdrop-blur-xl" : "border-b border-transparent"}`}>
      <div className="mx-auto flex h-[72px] max-w-[1400px] items-center justify-between px-5 sm:px-8">
        <Logo />
        <nav className="hidden items-center gap-8 lg:flex">{LINKS.map((l) => item(l))}</nav>
        <div className="flex items-center gap-3">
          <Link to="/eventos" data-testid="nav-find-photos-btn"
            className="group hidden items-center gap-2 rounded-full bg-flash px-5 py-2.5 text-sm font-semibold text-ink transition-[background-color,transform] duration-300 hover:scale-[1.03] hover:bg-flash-2 sm:inline-flex">
            Encontrar minhas fotos
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
          </Link>
          <button onClick={() => setOpen((o) => !o)} data-testid="nav-mobile-toggle" aria-label="Menu"
            className="grid h-11 w-11 place-items-center rounded-full border border-white/15 lg:hidden">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {open && (
        <div className="border-t border-white/10 px-5 pb-10 pt-6 lg:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-5">{LINKS.map((l) => item(l, true))}</div>
          <Link to="/eventos" className="mt-8 inline-flex rounded-full bg-flash px-6 py-3 font-semibold text-ink" data-testid="nav-mobile-find-photos">
            Encontrar minhas fotos
          </Link>
        </div>
      )}
    </header>
  );
};
